
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-blue-900 py-6">
      <div className="container mx-auto px-4 text-center text-white/50">
        <span className="font-bold text-4xl">
          <span className="text-white">REAL</span>
          <span className="text-orange-500">RISES</span>
        </span>
        
        <div className="text-xs md:text-sm mt-4">
          <p className="!pb-0">{t('footer.copyright')}</p>
          <p>
            <a className="text-orange-500 hover:text-orange-400 cursor-pointer" href="/privacy-policy">
              {t('footer.privacyPolicy')}
            </a>{' '}
            •{' '}
            <a className="text-orange-500 hover:text-orange-400 cursor-pointer" href="/terms-of-service">
              {t('footer.termsOfService')}
            </a>
          </p>
          
          <p className="max-w-xl mx-auto text-xs mt-4">
            {t('footer.disclaimer')}
            <br /><br />
            {t('footer.riskWarning')}
            <br /><br />
            {t('footer.agreement')}
          </p>
          
          <div className="mt-6 pt-4 border-t border-white/20">
            <p className="text-xs">
              {t('footer.madeWith')}{' '}
              <a 
                href="https://readdy.ai/?origin=logo" 
                className="text-orange-500 hover:text-orange-400 cursor-pointer"
                target="_blank"
                rel="noopener noreferrer"
              >
                Readdy
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
